import React, { useContext, useRef, useState } from 'react'
import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import Input from '../../../../../../FormComponents/Input'
import { toastError } from '../../../../../../FormComponents/Toasts'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { toastSuccess } from '../../../../../../FormComponents/Toasts'
import axiosService from '../../../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function AdvertiserPriceField({ action }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { campaign, primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)
  const formikRef = useRef()

  const resetFormValue = () => {
    formikRef.current?.setFieldValue('advertiser_price', action.advertiserPrice.toFixed(2))
  }

  const changeAdvertiserPrice = advertiser_price => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitAdvertiserMargin(advertiser_price), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const price = typeof values?.advertiser_price === 'object'
      ? values.advertiser_price?.advertiser_price
      : values?.advertiser_price
    submitAdvertiserMargin(price)
  }

  const submitAdvertiserMargin = advertiserPrice => {

    const targetPrice = parseFloat(advertiserPrice)
    if (!Number.isFinite(targetPrice)) {
      resetFormValue()
      return
    }

    if (Number.isFinite(action.influencer_payout_price) && targetPrice < action.influencer_payout_price) {
      toastError('Advertiser Price cannot be less than Influencer Payout Price')
      resetFormValue()
      return
    }

    const baseInfluencerPrice = action.influencerPrice
    const ksaPrice = action.ksaPrice || 0
    if (!Number.isFinite(baseInfluencerPrice) || baseInfluencerPrice <= 0) {
      toastError('Cannot update margin without a valid influencer price')
      resetFormValue()
      return
    }

    const newMargin = ((targetPrice - ksaPrice) / baseInfluencerPrice - 1) * 100
    if (!Number.isFinite(newMargin)) {
      resetFormValue()
      return
    }

    // action.advertiser_margin = newMargin

    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { advertiser_margin: newMargin }})
    .then((updatedAction) => {
      toastSuccess('Advertiser Price updated')
      action.advertiser_margin = updatedAction.advertiser_margin
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div>
      <Formik
        key={action.advertiserPrice}
        initialValues={{ advertiser_price: action.advertiserPrice.toFixed(2) }}
        enableReinitialize
        onSubmit={handleFormSubmit}
      >
        {({ handleBlur, handleChange, values, ...formik }) => {
          formikRef.current = formik
          return (
          <Form className="w-full">
            <Input
              disabled={readOnly}
              addon={campaign.currency_symbol}
              addonPosition="start"
              name="advertiser_price"
              noLabelPadding
              onChange={(e) => {
                changeAdvertiserPrice(e.target.value)
                handleChange(e)
              }}
              onBlur={handleBlur}
              value={values.advertiser_price}
              overrideClassName="h-7"
              topMargin="mt-0"
            />
          </Form>
          )
        }}
      </Formik>
    </div>
  )
})